import { Alert, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material"
import { useState } from "react"
import config from "../../common/Config"

const RecoverPassword = () => {

	const [returnObject, setReturnObject]			= useState()
	const [formState, setFormState]					= useState(formFields)

	const handleSubmit = (e) => {
		e.preventDefault()

		// Percorre todos os campos e verifica se está valido ou não
		Object.keys(formFields).map(k => {
			formFields[k].error = !e.target[k].validity.valid
		})
		
		if (e.target.checkValidity()) {
			fetch(config.apiUrl +'/recoverPassword/'+ formState.email.value)
			.then(result => result.json())
			.then(result => {
				if (result.status === 200) {
					setReturnObject({
						status		: "success",
						message		: "Procedimentos de recuperação de senha enviados. Verifique o seu e-mail"
					})
				}
				else {
					setReturnObject({
						status		: "error",
						message		: "E-mail não cadastrado!"
					})
				}
			})
		}
		else {
			setFormState(formFields)
		}
	}

	const handleFormChange = (e) => {
		setFormState(prevState => ({
			...prevState, 
			[e.target.name] : {
				value : e.target.value
			}
		}))
	}
	
	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', justifyContent: 'center' }} elevation={1}>
			<Box display={'flex'} width={'50%'} height={'100%'} alignItems={'center'}>
				<Stack component={'form'} direction={'column'} width={'100%'} spacing={2} onSubmit={handleSubmit} noValidate>
					<Typography variant="h5">Altere sua senha</Typography>
					{ returnObject ? <Alert severity={returnObject.status}>{returnObject.message}</Alert> : null}
					<TextField 
						type={"email"} 
						name="email"
						label="Digite o seu email" 
						value={formState.email.value} 
						onChange={handleFormChange}
						error={formState.email.error}
						helperText={formState.email.error && "Digite um e-mail válido!"}
						required 
						fullWidth
					/>
					<Button type="submit" variant="contained" sx={{width: 200}}>Enviar</Button>
				</Stack>
			</Box>
		</Paper>
	)
}

const formFields = {
	email : {
		error 	: false,
		value	: ''
	}
}

export default RecoverPassword